export default "__VITE_ASSET__DYNsikrn__"